import { Action } from '@ngrx/store';

export const CREATE_CODESYSTEMVERSION_DRAFT_SUCCESS = '[Vocabulary] Create CodeSystemVersion Draft Success';

export class CreateCodeSystemVersionDraftSuccessAction implements Action {
  readonly type = CREATE_CODESYSTEMVERSION_DRAFT_SUCCESS;

  constructor(public payload: { key: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/CreateCodeSystemVersionDraftSuccessAction.ts